import toastr from 'toastr'
import { user, DataLayer, twoFactorPolicy } from 'services'

const computed = {
  form () {
    return user.getUser();
  },
  twoFactorActionLabel () {
    return twoFactorPolicy.label(this.form && this.form.two_fa_action)
  }
}

const methods = {
  submit () {
    this.processing = true;
    let passwordChanged = !!this.form.password;
    this.$store.dispatch('user.updatePersonalData', this.form).then(() => {
      this.processing = false;
      let errors = this.$store.state.user.errors;
      if (errors) {
        if (errors.errors) {
          this.errors = _.cloneDeep(errors.errors);
        }
        toastr.error(errors.message);
      } else {
        toastr.success('Data has been saved');
        if (passwordChanged) {
          if (!isServer) {
            DataLayer.resetPassword(this.form.email,user.getUser());
          }
        }
      }
    })
  }
}

export default {
  name: 'profile-personal-info',
  computed,
  methods,
  data () {
    return {
      errors: {},
      processing: false
    }
  }
}
